import { useTranslation } from "@/hooks/useTranslation";
import { Monitor } from "lucide-react";

export function MobileBlocker() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--bg-page)",
        color: "var(--text-primary)",
        fontFamily: "'DM Sans', sans-serif",
        padding: "2rem",
        textAlign: "center",
        zIndex: 9999,
      }}
    >
      <Monitor size={48} style={{ color: "var(--brand-primary)", marginBottom: "1.5rem" }} />
      <h1 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: "0.75rem" }}>
        {t("mobile.title")}
      </h1>
      <p style={{ fontSize: "1rem", color: "var(--text-muted)", maxWidth: "24rem", lineHeight: 1.5 }}>
        {t("mobile.body")}
      </p>
    </div>
  );
}
